import { render, staticRenderFns } from "./indicadoresvariables.vue?vue&type=template&id=7517fa4c&"
import script from "./indicadoresvariables.vue?vue&type=script&lang=ts&"
export * from "./indicadoresvariables.vue?vue&type=script&lang=ts&"
import style0 from "./indicadoresvariables.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports